<section class="card-layout context-menu-wrapper Auto_ContextMenu_Wrapper"
         *ngIf="!!active"
         [ngStyle]="{'left.px':coordinates?.x+arrowPXOffset,'top.px':coordinates?.y-arrowPXOffset}">
  <span class="tooltip-arrow tooltip-arrow-right"></span>
  <ng-container [ngSwitch]="getEnum(type)">
    <gen-labels-color-menu
      *ngSwitchCase="getEnum('COLOR_LABEL')"
      (update)="updateEmit($event)"
    ></gen-labels-color-menu>
    <ng-content
      *ngSwitchCase="getEnum('CUSTOM')"
      (update)="updateEmit($event)"
    ></ng-content>
  </ng-container>
</section>
